import util from './util';
import map_dosha from './map/map_dosha';
window.onload = () => {
    createTabMenu(GM_ID_PC_DOSHA);
    comMain(() => {
        new mainDosha();
    });
};
/**
 * トップページ（土砂災害メッシュ）の処理
 */
export default class mainDosha extends map_dosha {
    /**
     * コンストラクタ
     */
    constructor() {
        super("mapShow", mainDosha.initMapPosition());
        this.setScale();
        this.setContorl();
        //  タブのメニュークリック時イベント
        //  「土砂災害メッシュ」タブ内の項目が選択された場合、ページ遷移はせずに表示を更新する。
        //  （それ以外のタブの項目が選択された場合は、ページ遷移する）
        $('#aDosha000').click(() => { this.mapChangeArea('000'); });
        $('#aDosha100').click(() => { this.mapChangeArea('100'); });
        $('#aDosha200').click(() => { this.mapChangeArea('200'); });
        $('#aDosha300').click(() => { this.mapChangeArea('300'); });
        $('#aDosha400').click(() => { this.mapChangeArea('400'); });
        $('#aDosha500').click(() => { this.mapChangeArea('500'); });
        $('#aDosha600').click(() => { this.mapChangeArea('600'); });
        $('#aDosha700').click(() => { this.mapChangeArea('700'); });
        $('#aDosha800').click(() => { this.mapChangeArea('800'); });
        this.displayPage();
        let scd = util.getUrlVars('scd');
        if (scd) {
            let shinkokyoku = getShinkokyoku(scd);
            this.displayMapInfo(scd, shinkokyoku);
        }
    }
    /**
     * デフォルト地図レイヤー
     */
    getDefaultLeyerId() {
        return config.initLayerId;
    }
    /**
     * 地図の初期表示位置を指定します
     */
    static initMapPosition() {
        //  
        let initMapZoomLevel = config.initMapZoomLevel;
        let initMapLatLon = config.initMapLatLon;
        //  クエリストリングを取得し、振興局の指定がある場合は座標指定をする
        let scd = util.getUrlVars('scd');
        if (scd) {
            let shinkokyoku = getShinkokyoku(scd);
            if (shinkokyoku) {
                initMapLatLon = shinkokyoku.latlon;
                initMapZoomLevel = shinkokyoku.zoomLevel;
            }
        }
        return {
            center: initMapLatLon,
            zoom: initMapZoomLevel,
            minZoom: config.mapMinZoomLevel,
            maxZoom: config.mapMaxZoomLevel,
        };
    }
    /**
     * 土砂メッシュページの描画
     */
    displayPage() {
        window.addEventListener('resize', () => {
            var height = window.innerHeight - 400;
            if (height < 600) {
                height = 600;
            }
            $('#mapShow').height(height);
        });
        //  地図表示と時刻設定
        let dispDoshaMap = () => {
            //  地図の更新チェックと表示
            this.checkUpdateLayer();
            //  地図の上部の更新時刻表示
            const updateTime = oldUpdatetimes.doshaMesh1k;
            $('#mapTitleDate').html(convertYmdToJpn(updateTime, true));
        };
        //  
        dispDoshaMap();
        //  振興局ボタンの配置
        //  mapCommonの関数を利用
        map = this.Map;
        addShinkokyokuMaker();
        //  一定間隔で危険度メッシュの更新有無を確認し
        //  更新があった場合、地図の再描画を行う
        setInterval(() => {
            dispDoshaMap();
        }, config.mapDataCheckMiliSec);
        //  common.js の共通処理を呼び出し
        //  地図以外の情報の表示を行う
        // 土砂災害警戒情報を表示
        dispDoshaStatus();
        // 洪水予報を表示		
        dispKouzuiStatus();
        // 警報／注意報を表示
        dispKeihouStatus();
        // 画面情報を取得
        var gamen = getMapGamen(GM_ID_PC_DOSHA);
        // 画面種別に応じて凡例を変更
        $('#hanreiImg').attr("src", getTimeUrl(gamen.hanreiImg));
        // お知らせを取得＆表示
        dispNotice('#notice');
        // お知らせの更新処理を設定
        setInterval(function () {
            try {
                dispNotice('#notice');
            }
            catch (error) {
                moveToError(ER_PROCESS);
            }
        }, config.noticeDataCheckMiliSec);
        this.setSerchControl('#search_f');
    }
    /**
     * 地図の表示位置変更
     * タブメニューの全県／各振興局のクリック時処理
     * @param scd
     */
    mapChangeArea(scd) {
        //  振興局情報の取得
        let shinkokyoku = getShinkokyoku(scd);
        //  表示地図の各種情報表示
        this.displayMapInfo(scd, shinkokyoku);
        //  指定した振興局に地図を移動＆拡大
        this.Map.setView(shinkokyoku.latlon, shinkokyoku.zoomLevel);
    }
    /**
     * 土砂災害メッシュ地図
     * メッシュクリック時イベント
     * @param properties
     */
    onMeshClick(properties) {
        let meshcode = properties.code; //  メッシュコード
        let url = "./uryoDetail.html?mesh=" + meshcode; //  接続URL
        this.selectMesh(meshcode);
        _showModalDialog(url);
    }
    /**
     * 表示地図の各種情報表示
     * @param scd
     * @param shinkokyoku
     */
    displayMapInfo(scd, shinkokyoku) {
        // パンくずリストを生成
        createNavi(GM_ID_PC_DOSHA, scd);
        // 地図右上の地名を設定
        $('#mapTitleArea').html(shinkokyoku.name);
    }
}
